import React from 'react';
import './CommunitySection.css';

const CommunitySection = () => {
  return (
    <section className="community-section motion-section">
      <h2 className="section-title">ATZ Community Corner</h2>

      <div className="community-bento-grid">
        {/* CARD 1: Financial Tips (Tall Vertical) */}
        <div className="bento-card card-tall">
          <div className="card-image-wrapper">
            <img 
              src="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=600&q=80" 
              alt="Financial Tips" 
              className="card-bg-image"
            />
            {/* Center Floating Bulb Overlay */}
            <div className="hero-floating-badge">
              <svg viewBox="0 0 48 48" className="badge-svg">
                <path d="M 24 6 C 15.16 6 8 13.16 8 22 C 8 27.2 10.48 31.84 14.32 34.8 C 15.38 35.62 16 36.88 16 38.2 L 16 40 C 16 41.1 16.9 42 18 42 L 30 42 C 31.1 42 32 41.1 32 40 L 32 38.2 C 32 36.88 32.62 35.62 33.68 34.8 C 37.52 31.84 40 27.2 40 22 C 40 13.16 32.84 6 24 6 Z" fill="#FBBF24" stroke="#D97706" strokeWidth="2.5" />
                <path d="M 18 42 L 30 42" stroke="#4B5563" strokeWidth="3" strokeLinecap="round" />
                <path d="M 20 46 L 28 46" stroke="#4B5563" strokeWidth="3" strokeLinecap="round" />
              </svg>
            </div>
          </div>
          <div className="card-content">
            <div className="corner-icon-badge badge-yellow">
              💡
            </div>
            <h4>Top-rated financial tips this month.</h4>
          </div>
        </div>

        {/* CARD 2: Ask an Expert (Tall Vertical) */}
        <div className="bento-card card-tall">
          <div className="card-image-wrapper">
            <img 
              src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=600&q=80" 
              alt="Ask an Expert" 
              className="card-bg-image"
            />
          </div>
          <div className="card-content">
            <div className="corner-icon-badge badge-blue">
              💬
            </div>
            <h4>Ask an Expert: Ask about budgeting.</h4>
          </div>
        </div>

        {/* CARD 3 & 4 COLUMN (Middle Right) */}
        <div className="bento-col-stacked">
          {/* Top Half-Card: Feature Updates */}
          <div className="bento-card card-landscape">
            <div className="card-image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=600&q=80" 
                alt="Working on laptop" 
                className="card-bg-image"
              />
              <div className="center-floating-icon purple-gear">
                ⚙️
              </div>
            </div>
          </div>

          {/* Bottom Card: Success Stories */}
          <div className="bento-card card-large-landscape">
            <div className="card-image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=800&q=80" 
                alt="Community success" 
                className="card-bg-image"
              />
            </div>
            <div className="card-content">
              <div className="corner-icon-badge badge-pink">
                👥
              </div>
              <h4>Community success stories.</h4>
            </div>
          </div>
        </div>

        {/* CARD 5: Feature Updates Card (Top Right Solid White) */}
        <div className="bento-card card-info-white">
          <div className="corner-icon-badge badge-purple-soft">
            ⚙️
          </div>
          <h4>Latest feature updates.</h4>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;